module.exports = __webpack_public_path__ + "img/banner3.973f07b5.png";